import { render, staticRenderFns } from "./editXkgc.vue?vue&type=template&id=07b65688&scoped=true&"
import script from "./editXkgc.vue?vue&type=script&lang=js&"
export * from "./editXkgc.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/mediaDetails/mediaCreat.less?vue&type=style&index=0&id=07b65688&lang=less&scoped=true&"
import style1 from "./editXkgc.vue?vue&type=style&index=1&id=07b65688&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b65688",
  null
  
)

component.options.__file = "editXkgc.vue"
export default component.exports